import axios from 'axios';
import store from '../store';

const resetMessage = require('../utils/resetMessage');
const Message = resetMessage.message;

let baseURL = '';
// 判断是否走nginx代理
if (process.env.VUE_APP_IS_API_PATH == 'YES') {
  baseURL = window.origin   + '/energyApi';
} else {
  // baseURL = process.env.VUE_APP_BASE_URL;
  baseURL = window.origin   + '/api';
}
if (baseURL === 'serve') {
  baseURL = '/api'; // 测试环境
  // baseURL = 'http://192.168.0.55:8222'; // 测试环境
  // baseURL = 'http://112.26.65.87:8222'; // 测试环境
}
// 创建 axios 实例
const instance = axios.create({
  baseURL, // 请求地址前缀，将自动加在 url 前面
  timeout: 1000000, // 请求超时时间
});
let requestUrls = []; // 请求数量

// axios请求拦截器
instance.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('token')||''; // token
    requestUrls.push(config.url);
    store.dispatch('app/showFullLoading', '数据加载中'); // 打开fullLoading
    config.headers['Content-Type'] = 'application/json;charset=utf-8'; // 设置请求头
    config.headers.Authorization = token;
    if (sessionStorage.getItem('organId')) { // 单点登录时获取的organId
      if (config.params) {
        config.params.organId = sessionStorage.getItem('organId');
      }
    } else { // 非单点登录时获取当前用户当前的organId
      if (sessionStorage.getItem('userInfo')) {
        if (config.params) {
          config.params.organId = JSON.parse(sessionStorage.getItem('userInfo')).currentOrgId;
        }
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 状态码判断
const errorHandle = ({ status, data: { message } }) => {
  switch (status) {
    case 404:
      Message.error('404错误，请求的资源不存在');
      break;
    case 500:
      Message.error('500错误，服务器内部错误');
      break;
    default:
      if (message) {
        Message.error(message);
      } else {
        Message.error('服务器错误');
      }
      break;
  }
};

// axios响应拦截器
instance.interceptors.response.use(
  (res) => {
    requestUrls.forEach((i, index) => {
      if (i === res.config.url) {
        requestUrls.splice(index, 1);
      }
    });
    setTimeout(() => {
      if (requestUrls.length === 0) {
        store.dispatch('app/closeFullLoading'); // 关闭fullLoading
      }
    }, 100);

    if (res.request.responseType === 'blob') {
      return res;
    }
    if (res.data.success) {
      return res.data;
    } else {
      if (res.status == 200) {
        return res.data;
      } else {
        Message.error(res.data.message);
        return Promise.reject(res.data);
      }
    }
  },
  (error) => {
    if (error.message.includes('timeout')) {
      Message.error('请求超时');
    } else {
      if (error.response && error.response.data) {
        errorHandle(error.response);
      } else {
        Message.error('请求错误');
      }
    }

    requestUrls.forEach((i, index) => {
      if (i === error.config.url) {
        requestUrls.splice(index, 1);
      }
    });
    setTimeout(() => {
      if (requestUrls.length === 0) {
        store.dispatch('app/closeFullLoading'); // 关闭fullLoading
      }
    }, 100);
    return Promise.reject(error);
  }
);

export default instance;
